__turbopack_context__.v({
  "container": "ArticleAuthorWithDate-module__j6aigG__container",
});
